import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import React, { useState, useContext } from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import HourRentalBasicRateDrawer from "components/drawer/HourRentalBasicRateDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import ConfirmActiveModal from "components/form/ConfirmActiveModal";
import SeoManageCityServices from "services/SeoManageCityServices";
import { notifySuccess } from "utils/toast";
import { SidebarContext } from "context/SidebarContext";

const SeoManageCityTable = ({
  hourRentalBasicRate,
  perpage,
  currentPage,
  hideEdit,
}) => {
  const { title, serviceId } = useToggleDrawer();
  const { setIsUpdate } = useContext(SidebarContext);

  const [showActiveModal, setShowActiveModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [status, setStatus] = useState(false);
  const handleUpdateStatusConfirm = () => {
    handleUpdateStatus(activeIndex);
    setShowActiveModal(false);
  };
  const handleUpdateStatus = async (i) => {
    const dataValues = {
      seo_active: !status,
    };
    const res = await SeoManageCityServices.updateSeoCity(i, dataValues);
    setIsUpdate(true);
    notifySuccess(res.message);
  };
  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <HourRentalBasicRateDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {hourRentalBasicRate?.slice(0, perpage).map((data, index) => (
          <TableRow key={index}>
            <TableCell className="text-center text-sm">
              {(currentPage - 1) * perpage + index + 1}
            </TableCell>
            <TableCell className="text-center text-sm">
              {data["city_name"]}
            </TableCell>
            <TableCell className="text-center text-sm">
              {data["state_name"]}
            </TableCell>
            <TableCell className="text-center text-sm">
              {data["country_name"]}
            </TableCell>

            <TableCell className="text-center">
              {hideEdit && (
                <input
                  type="checkbox"
                  checked={data["seo_active"]}
                  onChange={() => {
                    setActiveIndex(data.id_city);
                    setShowActiveModal(true);
                    setStatus(data["seo_active"]);
                  }}
                />
              )}
            </TableCell>

            <TableCell className="text-center text-xs">
              {data["seo_active"] === true ? (
                <span className="text-green-500">Active</span>
              ) : (
                <span className="text-red-600">Inactive</span>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
      <ConfirmActiveModal
        isOpen={showActiveModal}
        status={status}
        onClose={() => setShowActiveModal(false)}
        onConfirm={handleUpdateStatusConfirm}
      />
    </>
  );
};

export default SeoManageCityTable;
